import {IListing} from "../models/listing.model";

export const listingUrl = (listing: IListing) => {
  const url = new URL(listing.uri);
  return url.pathname;
}